/**
 * Which playing style (P5) the robot opponent gets for a new game — resolved
 * ONCE at `startGame` and snapshotted into the game store next to `level`.
 *
 * Two gates make style opt-out where determinism is load-bearing:
 *
 * 1. **`AUDIT_CAPTURE=1`** → null. The audit flows pin exact moves with the
 *    real engine (e.g. checkers `1. a3-b4 b6-a5`, where depth-2 replies are
 *    near-ties a style could reorder), and the spec's own risk row sanctions
 *    it: "Goldens flake | Audit mode keeps bubbles, music and timers off."
 *    Evaluated at CALL TIME (a module-level const would defeat
 *    `vi.stubEnv('AUDIT_CAPTURE', '1')`, the same gotcha `toast-store.ts`
 *    documents).
 * 2. **`?engine=fake`** → null. The fake engine emits three MultiPV lines at
 *    `score cp 0` — all inside any window — so a style could override the
 *    scripted move and break `golden-path` / the chess audit flow.
 *
 * Everything else is plain play: the chosen persona's profile, so the default
 * persona (marisol/solid) styles the default robot by design.
 */
import { styleForPersona, type PlayStyle } from '@strategy4kids/persona';
import { usePersonaStore } from '../state/persona-store.js';
import type { AppQuery } from './query.js';

export function resolveRobotStyle(query: AppQuery): PlayStyle | null {
  if (import.meta.env.AUDIT_CAPTURE === '1') return null;
  if (query.engine === 'fake') return null;
  return styleForPersona(usePersonaStore.getState().personaId) ?? null;
}
